import { create } from "zustand";

import { FontFamilyPreset, typographyTokens } from "@/theme/tokens/typography";
import { ThemeColorPresets, ThemeLayout, ThemeMode } from "#/enum";
import { removePx } from "@/utils/theme";

export type SettingsType = {
	themeColorPresets: ThemeColorPresets;
	themeMode: ThemeMode;
	themeLayout: ThemeLayout;
	themeStretch: boolean;
	breadCrumb: boolean;
	accordion: boolean;
	multiTab: boolean;
	darkSidebar: boolean;
	fontFamily: string;
	fontSize: number;
	direction: "ltr" | "rtl";
};
type SettingStore = {
	settings: SettingsType;
	// 使用 actions 命名空间来存放所有的 action
	actions: {
		setSettings: (settings: SettingsType) => void;
		clearSettings: () => void;
	};
};

const useSettingStore = create<SettingStore>()((set) => ({
	settings: {
		themeColorPresets: ThemeColorPresets.Default,
		themeMode: ThemeMode.Light,
		themeLayout: ThemeLayout.Vertical,
		themeStretch: true,
		breadCrumb: true,
		accordion: false,
		multiTab: false,
		darkSidebar: false,
		fontFamily: FontFamilyPreset.openSans,
		fontSize: Number(removePx(typographyTokens.fontSize.sm)),
		direction: "ltr",
	},
	actions: {
		setSettings: (settings) => {
			set({ settings });
		},
		clearSettings() {
			// useSettingStore.persist.clearStorage();
		},
	},
}));

export const useSettings = () => useSettingStore((state) => state.settings);
export const useSettingActions = () =>
	useSettingStore((state) => state.actions);
